import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileNav", "scrollTop", "toggle"]

  connect() {
    this.boundHandleScroll = this.handleScroll.bind(this)
    this.boundCloseDropdowns = this.closeAllDropdowns.bind(this)

    this.handleScroll()
    window.addEventListener('scroll', this.boundHandleScroll, { passive: true })
    document.addEventListener('click', this.boundCloseDropdowns)
    this.setupDropdowns()
    this.setupMobileNavLinks()
  }

  disconnect() {
    window.removeEventListener('scroll', this.boundHandleScroll)
    document.removeEventListener('click', this.boundCloseDropdowns)
  }

  setupDropdowns() {
    // Setup dropdown toggles
    const dropdownToggles = document.querySelectorAll('.toggle-dropdown')
    
    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        const parentLi = toggle.closest('li.dropdown')
        const dropdown = parentLi.querySelector('ul')
        
        // Close all other dropdowns
        document.querySelectorAll('.dropdown ul').forEach(menu => {
          if (menu !== dropdown) {
            menu.classList.remove('dropdown-active')
          }
        })
        
        // Toggle this dropdown
        dropdown.classList.toggle('dropdown-active')
        
        // Toggle icon
        toggle.classList.toggle('bi-chevron-up')
        toggle.classList.toggle('bi-chevron-down')
      })
    })
  }

  closeAllDropdowns() {
    document.querySelectorAll('.dropdown ul').forEach(dropdown => {
      dropdown.classList.remove('dropdown-active')
    })

    document.querySelectorAll('.toggle-dropdown').forEach(toggle => {
      toggle.classList.remove('bi-chevron-up')
      toggle.classList.add('bi-chevron-down')
    })
  }

  handleScroll() {
    const header = document.getElementById('header')
    if (window.scrollY > 50) {
      header.classList.add('header-scrolled')
    } else {
      header.classList.remove('header-scrolled')
    }
    
    // Show/hide scroll to top button
    if (this.hasScrollTopTarget) {
      if (window.scrollY > 100) {
        this.scrollTopTarget.classList.add('active')
      } else {
        this.scrollTopTarget.classList.remove('active')
      }
    }
  }

  toggleMobileNav() {
    if (this.hasMobileNavTarget) {
      const mobileNav = this.mobileNavTarget
      const toggleButton = this.hasToggleTarget ? this.toggleTarget : document.querySelector('.mobile-nav-toggle')
      const toggleIcon = toggleButton.querySelector('i') || toggleButton
      const body = document.body

      // Toggle the active class
      mobileNav.classList.toggle('mobile-nav-active')

      const isExpanded = mobileNav.classList.contains('mobile-nav-active')

      // Update aria-expanded for accessibility
      toggleButton.setAttribute('aria-expanded', isExpanded.toString())

      // Toggle the icon between list (menu) and x (close)
      if (isExpanded) {
        toggleIcon.classList.remove('bi-list')
        toggleIcon.classList.add('bi-x')
        // Prevent scrolling when menu is open
        body.style.overflow = 'hidden'

        // Reposition the toggle button to be visible within the menu
        toggleButton.style.right = '15px'
      } else {
        toggleIcon.classList.remove('bi-x')
        toggleIcon.classList.add('bi-list')
        // Restore scrolling when menu is closed
        body.style.overflow = ''

        // Reset toggle button position
        toggleButton.style.right = '15px'
      }
    }
  }
  
  // Overlay methods removed
  
  scrollToTop(event) {
    event.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  
  setupMobileNavLinks() {
    if (this.hasMobileNavTarget) {
      const mobileNav = this.mobileNavTarget
      const navLinks = mobileNav.querySelectorAll('a:not(.toggle-dropdown)')
      
      navLinks.forEach(link => {
        link.addEventListener('click', () => {
          // Close the mobile menu when a link is clicked
          if (mobileNav.classList.contains('mobile-nav-active')) {
            this.toggleMobileNav()
          }
        })
      })
    }
  }
}
